import type { MenuDataItem } from '@ant-design/pro-components';

const SYSTEM_MANAGEMENT_PATH = '/system';

function belongsToSystemManagement(item: MenuDataItem): boolean {
  if (item.path === SYSTEM_MANAGEMENT_PATH || item.path?.startsWith(`${SYSTEM_MANAGEMENT_PATH}/`)) {
    return true;
  }
  return item.children?.some(belongsToSystemManagement) ?? false;
}

/**
 * 将包含系统管理路由的一级菜单统一放到末尾，保持其他菜单之间的原有顺序。
 * 后端目录节点可能没有 path，因此同时检查其子菜单的 `/system/*` 路由。
 */
export function placeSystemManagementLast(items: MenuDataItem[]): MenuDataItem[] {
  const businessMenus: MenuDataItem[] = [];
  const systemMenus: MenuDataItem[] = [];

  for (const item of items) {
    (belongsToSystemManagement(item) ? systemMenus : businessMenus).push(item);
  }
  return [...businessMenus, ...systemMenus];
}
